import { SavedReports } from '../components/Reports/SavedReports';

export function SavedReportsPage() {
  return <SavedReports />;
}
